import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, withKeys as _withKeys, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"
import _imports_0 from '../assets/images/footerIcons.svg'
import _imports_1 from '@/assets/images/defaultImage.png'


const _hoisted_1 = { class: "flex" }
const _hoisted_2 = {
  key: 1,
  class: "form"
}
const _hoisted_3 = {
  key: 2,
  class: "loading"
}
const _hoisted_4 = {
  class: "profile-pic",
  initial: {
              opacity: 0,
              y: 100
            },
  visible: {
              opacity: 1,
              y: 0,
              transition: {
                duration: 300,
                type: 'keyframes',
                ease: 'easeIn',
              }
            }
}
const _hoisted_5 = ["src"]
const _hoisted_6 = {
  key: 1,
  src: _imports_1
}
const _hoisted_7 = { class: "ion-text-center" }
const _hoisted_8 = {
  key: 3,
  class: "wrapped"
}
const _hoisted_9 = { class: "user-info" }
const _hoisted_10 = {
  class: "profile-pic",
  initial: {
                opacity: 0,
                y: 100
              },
  visible: {
                opacity: 1,
                y: 0,
                transition: {
                  duration: 300,
                  type: 'keyframes',
                  ease: 'easeIn',
                }
              }
}
const _hoisted_11 = ["src"]
const _hoisted_12 = {
  key: 1,
  src: _imports_1
}
const _hoisted_13 = { class: "ion-text-center" }
const _hoisted_14 = {
  key: 0,
  id: "gitHub",
  class: "info"
}
const _hoisted_15 = {
  key: 1,
  id: "gitLab",
  class: "info"
}
const _hoisted_16 = {
  id: "clickUp",
  class: "info"
}
const _hoisted_17 = {
  key: 2,
  id: "superSet",
  class: "info"
}
const _hoisted_18 = {
  key: 3,
  id: "nifi",
  class: "info"
}
const _hoisted_19 = {
  id: "slack",
  class: "info"
}
const _hoisted_20 = {
  key: 4,
  id: "Meetings",
  class: "info"
}
const _hoisted_21 = {
  key: 5,
  id: "figma",
  class: "info"
}
const _hoisted_22 = { class: "center-block" }
const _hoisted_23 = {
  id: "credits",
  class: "center-block"
}
const _hoisted_24 = { class: "buttons" }

import { alertController, IonButton, IonContent, IonFab, IonFabButton, IonIcon, IonInput, IonItem, IonLabel, IonPage, IonProgressBar } from "@ionic/vue";
import Logo from "@/components/Logo.vue";
import { arrowDownOutline, bugOutline, calendarOutline, chatbubbleEllipsesOutline, checkmarkDone, checkmarkDoneOutline, createOutline, fitnessOutline, giftOutline, gitPullRequestOutline, headsetOutline, layersOutline, logoFigma, logoGithub, logoGitlab, logoSlack, mailOpenOutline, moonOutline, rocketOutline, shuffleOutline, speedometerOutline, ticketOutline, timerOutline } from "ionicons/icons"
import { onMounted, ref, watch } from "vue";
import DataCard from "@/components/DataCard.vue"
import ListCard from "@/components/ListCard.vue"
import BarChartCard from "@/components/BarChartCard.vue"
import { Chart as ChartJS, ArcElement, Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale } from 'chart.js'
import DoughnutChartCard from "@/components/DoughnutChartCard.vue";
import { useMotion } from "@vueuse/motion";


export default /*@__PURE__*/_defineComponent({
  __name: 'Home',
  setup(__props) {

ChartJS.register(ArcElement, Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale)
const confetti = require('canvas-confetti');

const email = ref("")
const isLogin = ref(true)
let loading = ref(0)
let isLoading = ref(false)
let data = ref({}) as any
let primaryColor = ref('')
let currentUser = ref({}) as any
let errorInput = ref("")
const scrollDown = ref()

var style = window.getComputedStyle(document.body)

const { variant } = useMotion(scrollDown, {
  initial: {
    y: 100,
    opacity: 0,
  },
  enter: {
    y: 0,
    opacity: 1,
    transition: {
      type: "spring",
      stiffness: 350,
      damping: 20,
      delay: 50,
      onComplete: () => {
        variant.value = "levitate";
      },
    },
  },
  levitate: {
    y: 15,
    transition: {
      duration: 2000,
      repeat: Infinity,
      ease: "easeInOut",
      repeatType: "mirror",
    },
  },
});

onMounted(() => {
  primaryColor.value = style.getPropertyValue('--ion-color-primary')

  try {
    data.value = require("../assets/json/users.json")
  } catch(err) {
    console.log('error', err);
  }

  let canvas = document.getElementById('card') as any;
  if(canvas) {
    canvas.confetti = canvas.confetti || confetti.create(canvas, { resize: true });
    canvas.confetti({
      spread: 70,
      particleCount: 100,
      origin: { y: 1.2 }
    });
  }
})

watch(email, () => {
  errorInput.value = ""
})

function scrollToElement() {
  let elementId = "info"

  const el = document.getElementsByClassName(elementId);
  if (el.length) el[0].scrollIntoView({ behavior: 'smooth' });
}

function redirect() {
  window.open("https://forms.gle/hrZkyCqVYBhxYFgF7", "_blank")
}

function replay() {
  email.value = ""
  isLogin.value = true
  loading.value = 0
  isLoading.value = false
  currentUser.value = {}
  errorInput.value = ""
}

async function presentAlert(message: string, header?: string) {
  const alert = await alertController.create({
    header,
    message,
    buttons: [
      {
        text: "Give feedback!",
        handler: () => {
          redirect()
        }
      },
      {
        text: "Okay!",
      }
    ],
  });
  return alert.present();
}

async function fetchData() {
  if(!(email.value && (email.value.includes("@hotwax.co") || email.value.includes("@hotwaxsystems.com")))) {
    errorInput.value = "Enter valid email"
    return;
  }

  const user = email.value.split("@")[0];

  if(!user) {
    errorInput.value = "Enter valid email"
    return;
  }

  currentUser.value = data.value[user];

  if(!currentUser.value || !Object.keys(currentUser.value)?.length) {
    presentAlert("You have done some amazing work this year 🎉, but due to some technical limitations we are unable to fetch your data.<br/ ><br/ >Please check this project again next year.<br/> <br/>Thank You and Happy New Year. 🥳")
    return;
  }
  
  if(currentUser.value) {
    isLogin.value = false
    isLoading.value = true

    const interval = setInterval(() => {
      loading.value += 0.01;

      if(loading.value > 1) {
        clearInterval(interval)
        isLoading.value = false
      }
    }, 50);
  }
}

return (_ctx: any,_cache: any) => {
  const _directive_motion = _resolveDirective("motion")!

  return (_openBlock(), _createBlock(_unref(IonPage), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonContent), null, {
        default: _withCtx(() => [
          _createElementVNode("main", _hoisted_1, [
            (isLogin.value || _unref(isLoading))
              ? (_openBlock(), _createBlock(Logo, { key: 0 }))
              : _createCommentVNode("", true),
            (isLogin.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  _createVNode(_unref(IonLabel), { class: "ion-text-center ion-margin-bottom" }, {
                    default: _withCtx(() => _cache[3] || (_cache[3] = [
                      _createElementVNode("h1", null, _toDisplayString("'24 Wrapped"), -1)
                    ])),
                    _: 1
                  }),
                  _createVNode(_unref(IonLabel), { class: "ion-text-center ion-margin-bottom" }, {
                    default: _withCtx(() => _cache[4] || (_cache[4] = [
                      _createElementVNode("p", null, _toDisplayString("Every effort, every idea, every win — big or small — has contributed to something greater. It’s time to look back and see the impact you’ve created this year."), -1)
                    ])),
                    _: 1
                  }),
                  _createVNode(_unref(IonItem), {
                    lines: "none",
                    class: "ion-margin-bottom"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonInput), {
                        "error-text": _unref(errorInput),
                        label: "Email",
                        "label-placement": "fixed",
                        name: "email",
                        modelValue: email.value,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((email).value = $event)),
                        id: "email",
                        type: "email",
                        required: "",
                        onKeyup: _withKeys(fetchData, ["enter"])
                      }, null, 8, ["error-text", "modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(IonButton), {
                    expand: "block",
                    onClick: fetchData,
                    disabled: !email.value
                  }, {
                    default: _withCtx(() => [
                      _cache[5] || (_cache[5] = _createTextVNode(" Unwrap my year ")),
                      _createVNode(_unref(IonIcon), {
                        slot: "end",
                        icon: _unref(giftOutline)
                      }, null, 8, ["icon"])
                    ]),
                    _: 1
                  }, 8, ["disabled"]),
                  _cache[6] || (_cache[6] = _createElementVNode("img", {
                    src: _imports_0,
                    alt: "",
                    class: "platform-icons"
                  }, null, -1))
                ]))
              : (_unref(isLoading))
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_4, [
                      (_unref(currentUser).headshot)
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 0,
                            src: `assets/images/headShots/${_unref(currentUser).headshot}.png`
                          }, null, 8, _hoisted_5))
                        : (_openBlock(), _createElementBlock("img", _hoisted_6))
                    ])), [
                      [_directive_motion]
                    ]),
                    _createElementVNode("h1", _hoisted_7, _toDisplayString(_unref(currentUser).firstName) + " " + _toDisplayString(_unref(currentUser).middleName) + " " + _toDisplayString(_unref(currentUser).lastName), 1),
                    _cache[8] || (_cache[8] = _createElementVNode("h3", { class: "ion-text-center" }, "You've had a big year. Lets break it down!", -1)),
                    _createVNode(_unref(IonProgressBar), {
                      color: _unref(loading) <= 0.3 ? 'primary' : _unref(loading) > 0.3 && _unref(loading) <= 0.5 ? 'secondary' : _unref(loading) > 0.5 && _unref(loading) <= 0.7 ? 'tertiary' : 'success',
                      value: _unref(loading),
                      class: "ion-margin-bottom"
                    }, null, 8, ["color", "value"]),
                    _createVNode(_unref(IonLabel), { class: "ion-text-center ion-margin-bottom" }, {
                      default: _withCtx(() => [
                        _createElementVNode("p", null, _toDisplayString(_unref(loading) <= 0.3 ? "Loading your year..." : _unref(loading) > 0.3 && _unref(loading) <= 0.5 ? "Counting your contributions" : _unref(loading) > 0.5 && _unref(loading) <= 0.7 ? "Pulling in your prodest moments..." : "Almost there..."), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(IonLabel), { class: "ion-text-center" }, {
                      default: _withCtx(() => _cache[7] || (_cache[7] = [
                        _createElementVNode("h4", null, _toDisplayString("Your year was full of wins, teamwork, and growth. Let's see everything you made happen."), -1)
                      ])),
                      _: 1
                    })
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _createElementVNode("section", _hoisted_9, [
                      _createVNode(Logo),
                      _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_10, [
                        (_unref(currentUser).headshot)
                          ? (_openBlock(), _createElementBlock("img", {
                              key: 0,
                              src: `assets/images/headShots/${_unref(currentUser).headshot}.png`
                            }, null, 8, _hoisted_11))
                          : (_openBlock(), _createElementBlock("img", _hoisted_12))
                      ])), [
                        [_directive_motion]
                      ]),
                      _createElementVNode("h1", _hoisted_13, _toDisplayString(_unref(currentUser).firstName) + " " + _toDisplayString(_unref(currentUser).middleName) + " " + _toDisplayString(_unref(currentUser).lastName), 1),
                      _cache[9] || (_cache[9] = _createElementVNode("h3", { class: "ion-text-center" }, "Let's see your 2024 story.", -1)),
                      _createVNode(_unref(IonFab), {
                        ref_key: "scrollDown",
                        ref: scrollDown,
                        class: "ion-margin-top",
                        horizontal: "center",
                        onClick: scrollToElement
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(IonFabButton), null, {
                            default: _withCtx(() => [
                              _createVNode(_unref(IonIcon), { icon: _unref(arrowDownOutline) }, null, 8, ["icon"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 512)
                    ]),
                    (_unref(currentUser)?.ghTotalPrs || _unref(currentUser)?.ghTopRepo || _unref(currentUser)?.ghFastestPr || _unref(currentUser)?.ghTotalContributions || _unref(currentUser)?.ghMerges)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                          _cache[10] || (_cache[10] = _createElementVNode("h1", { class: "title ion-margin-start" }, "GitHub", -1)),
                          (_unref(currentUser)?.ghTotalPrs)
                            ? (_openBlock(), _createBlock(DataCard, {
                                key: 0,
                                "sub-title": "Pull requests",
                                icon: _unref(logoGithub),
                                value: _unref(currentUser)?.ghTotalPrs,
                                "additional-info": "Pull requests created by you were merged on GitHub"
                              }, null, 8, ["icon", "value"]))
                            : _createCommentVNode("", true),
                          (_unref(currentUser)?.ghTopRepo)
                            ? (_openBlock(), _createBlock(ListCard, {
                                key: 1,
                                "sub-title": "Top repositories",
                                value: _unref(currentUser)?.ghTopRepo,
                                suffix: "commit"
                              }, null, 8, ["value"]))
                            : _createCommentVNode("", true),
                          (_unref(currentUser)?.ghFastestPr)
                            ? (_openBlock(), _createBlock(BarChartCard, {
                                key: 2,
                                "sub-title": "Fastest PR",
                                data: _unref(currentUser)?.ghFastestPr
                              }, null, 8, ["data"]))
                            : _createCommentVNode("", true),
                          (_unref(currentUser)?.ghTotalContributions)
                            ? (_openBlock(), _createBlock(DataCard, {
                                key: 3,
                                "sub-title": "Contributions",
                                icon: _unref(logoGithub),
                                value: _unref(currentUser)?.ghTotalContributions,
                                "additional-info": "Across all repositories"
                              }, null, 8, ["icon", "value"]))
                            : _createCommentVNode("", true),
                          (_unref(currentUser)?.ghMerges)
                            ? (_openBlock(), _createBlock(DataCard, {
                                key: 4,
                                "sub-title": "Owning the commit",
                                icon: _unref(gitPullRequestOutline),
                                value: _unref(currentUser)?.ghMerges,
                                "additional-info": "Pull requests merged by you this year on GitHub"
                              }, null, 8, ["icon", "value"]))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true),
                    (_unref(currentUser)?.glTotalMrs || _unref(currentUser)?.glTopRepo || _unref(currentUser)?.glMerges || _unref(currentUser)?.glFvB)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                          _cache[11] || (_cache[11] = _createElementVNode("h1", { class: "title ion-margin-start" }, "GitLab", -1)),
                          (_unref(currentUser)?.glTotalMrs)
                            ? (_openBlock(), _createBlock(DataCard, {
                                key: 0,
                                "sub-title": "Merge requests",
                                icon: _unref(logoGitlab),
                                value: _unref(currentUser)?.glTotalMrs,
                                "additional-info": "Pull requests created by you were merged on GitLab"
                              }, null, 8, ["icon", "value"]))
                            : _createCommentVNode("", true),
                          (_unref(currentUser)?.glTopRepo)
                            ? (_openBlock(), _createBlock(ListCard, {
                                key: 1,
                                "sub-title": "Top repositories",
                                value: _unref(currentUser)?.glTopRepo,
                                suffix: "commit"
                              }, null, 8, ["value"]))
                            : _createCommentVNode("", true),
                          (_unref(currentUser)?.glMerges)
                            ? (_openBlock(), _createBlock(DataCard, {
                                key: 2,
                                "sub-title": "Owning the commit",
                                icon: _unref(gitPullRequestOutline),
                                value: _unref(currentUser)?.glMerges,
                                "additional-info": "Pull requests merged by you this year on GitLab"
                              }, null, 8, ["icon", "value"]))
                            : _createCommentVNode("", true),
                          (_unref(currentUser)?.glFvB)
                            ? (_openBlock(), _createBlock(DoughnutChartCard, {
                                key: 3,
                                "sub-title": "Feature vs Bug",
                                icon: _unref(bugOutline),
                                data: _unref(currentUser)?.glFvB,
                                "additional-info": "Bug fix merge requests"
                              }, null, 8, ["icon", "data"]))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_16, [
                      _cache[12] || (_cache[12] = _createElementVNode("h1", { class: "title ion-margin-start" }, "ClickUp", -1)),
                      (_unref(currentUser)?.cuTickets)
                        ? (_openBlock(), _createBlock(DataCard, {
                            key: 0,
                            "sub-title": "Tickets",
                            icon: _unref(ticketOutline),
                            value: _unref(currentUser)?.cuTickets,
                            "additional-info": "Created this year by you"
                          }, null, 8, ["icon", "value"]))
                        : _createCommentVNode("", true),
                      _createVNode(DataCard, {
                        "sub-title": "Closed",
                        icon: _unref(checkmarkDone),
                        value: "1492",
                        "additional-info": "Tickets this year as a team"
                      }, null, 8, ["icon"])
                    ]),
                    (_unref(currentUser)?.ssDataSets || _unref(currentUser)?.ssCharts || _unref(currentUser)?.ssDashboards || _unref(currentUser)?.ssClients)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                          _cache[13] || (_cache[13] = _createElementVNode("h1", { class: "title ion-margin-start" }, "SuperSet", -1)),
                          (_unref(currentUser)?.ssDataSets)
                            ? (_openBlock(), _createBlock(DataCard, {
                                key: 0,
                                "sub-title": "Data Sets",
                                icon: _unref(layersOutline),
                                value: _unref(currentUser)?.ssDataSets,
                                "additional-info": "Created and SQLs added"
                              }, null, 8, ["icon", "value"]))
                            : _createCommentVNode("", true),
                          (_unref(currentUser)?.ssCharts)
                            ? (_openBlock(), _createBlock(DataCard, {
                                key: 1,
                                "sub-title": "Reports & Alerts",
                                icon: _unref(fitnessOutline),
                                value: _unref(currentUser)?.ssCharts,
                                "additional-info": "Created this year by you"
                              }, null, 8, ["icon", "value"]))
                            : _createCommentVNode("", true),
                          (_unref(currentUser)?.ssDashboards)
                            ? (_openBlock(), _createBlock(DataCard, {
                                key: 2,
                                "sub-title": "Dashboards",
                                icon: _unref(speedometerOutline),
                                value: _unref(currentUser)?.ssDashboards,
                                "additional-info": "Managed by you"
                              }, null, 8, ["icon", "value"]))
                            : _createCommentVNode("", true),
                          (_unref(currentUser)?.ssClients)
                            ? (_openBlock(), _createBlock(ListCard, {
                                key: 3,
                                "sub-title": "Clients",
                                value: _unref(currentUser)?.ssClients,
                                suffix: "chart"
                              }, null, 8, ["value"]))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true),
                    (_unref(currentUser)?.nfProcessors || _unref(currentUser)?.nfTopProcessors || _unref(currentUser)?.nfFlow)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                          _cache[14] || (_cache[14] = _createElementVNode("h1", { class: "title ion-margin-start" }, "NiFi", -1)),
                          (_unref(currentUser)?.nfProcessors)
                            ? (_openBlock(), _createBlock(DataCard, {
                                key: 0,
                                "sub-title": "Processors",
                                icon: _unref(shuffleOutline),
                                value: _unref(currentUser)?.nfProcessors,
                                "additional-info": "Updated by you"
                              }, null, 8, ["icon", "value"]))
                            : _createCommentVNode("", true),
                          (_unref(currentUser)?.nfTopProcessors)
                            ? (_openBlock(), _createBlock(ListCard, {
                                key: 1,
                                "sub-title": "Favorite processors",
                                value: _unref(currentUser)?.nfTopProcessors
                              }, null, 8, ["value"]))
                            : _createCommentVNode("", true),
                          (_unref(currentUser)?.nfFlow)
                            ? (_openBlock(), _createBlock(DataCard, {
                                key: 2,
                                "sub-title": "Flows",
                                icon: _unref(createOutline),
                                value: _unref(currentUser)?.nfFlow,
                                "additional-info": "Created by you this year"
                              }, null, 8, ["icon", "value"]))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_19, [
                      _cache[15] || (_cache[15] = _createElementVNode("h1", { class: "title ion-margin-start" }, "Slack", -1)),
                      (_unref(currentUser)?.slDays)
                        ? (_openBlock(), _createBlock(DataCard, {
                            key: 0,
                            "sub-title": "Days active",
                            icon: _unref(logoSlack),
                            value: _unref(currentUser)?.slDays,
                            "additional-info": "+ Active days this year"
                          }, null, 8, ["icon", "value"]))
                        : _createCommentVNode("", true),
                      (_unref(currentUser)?.slMessages)
                        ? (_openBlock(), _createBlock(DataCard, {
                            key: 1,
                            "sub-title": "Messages",
                            icon: _unref(mailOpenOutline),
                            value: _unref(currentUser)?.slMessages,
                            "additional-info": "Sent by you this year"
                          }, null, 8, ["icon", "value"]))
                        : _createCommentVNode("", true),
                      _createVNode(DataCard, {
                        "sub-title": "Support",
                        icon: _unref(headsetOutline),
                        value: "266",
                        "additional-info": "HotWax Support active days this year"
                      }, null, 8, ["icon"]),
                      _createVNode(DataCard, {
                        "sub-title": "Support",
                        icon: _unref(chatbubbleEllipsesOutline),
                        value: "1622",
                        "additional-info": "Messages sent by HotWax Support this year"
                      }, null, 8, ["icon"])
                    ]),
                    (_unref(currentUser)?.gmMeetings || _unref(currentUser)?.gmClients || _unref(currentUser)?.gmHours || _unref(currentUser)?.gmMinutes)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                          _cache[16] || (_cache[16] = _createElementVNode("h1", { class: "title ion-margin-start" }, "Meetings", -1)),
                          (_unref(currentUser)?.gmMeetings)
                            ? (_openBlock(), _createBlock(DataCard, {
                                key: 0,
                                "sub-title": "Meetings",
                                icon: _unref(calendarOutline),
                                value: _unref(currentUser)?.gmMeetings,
                                "additional-info": "Taken this year"
                              }, null, 8, ["icon", "value"]))
                            : _createCommentVNode("", true),
                          (_unref(currentUser)?.gmClients)
                            ? (_openBlock(), _createBlock(ListCard, {
                                key: 1,
                                "sub-title": "Clients",
                                icon: _unref(rocketOutline),
                                value: _unref(currentUser)?.gmClients
                              }, null, 8, ["icon", "value"]))
                            : _createCommentVNode("", true),
                          (_unref(currentUser)?.gmHours)
                            ? (_openBlock(), _createBlock(DataCard, {
                                key: 2,
                                "sub-title": "Hours",
                                icon: _unref(moonOutline),
                                value: _unref(currentUser)?.gmHours,
                                "additional-info": "Hours invested by you"
                              }, null, 8, ["icon", "value"]))
                            : _createCommentVNode("", true),
                          (_unref(currentUser)?.gmMinutes)
                            ? (_openBlock(), _createBlock(DataCard, {
                                key: 3,
                                "sub-title": "Minutes",
                                icon: _unref(timerOutline),
                                value: _unref(currentUser)?.gmMinutes,
                                "additional-info": "Minutes invested by you"
                              }, null, 8, ["icon", "value"]))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true),
                    (_unref(currentUser)?.fgReleaseNotes || _unref(currentUser)?.fgWebsite || _unref(currentUser)?.fgDocumentation || _unref(currentUser)?.fgEvent)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                          _cache[17] || (_cache[17] = _createElementVNode("h1", { class: "title ion-margin-start" }, "Figma", -1)),
                          (_unref(currentUser)?.fgReleaseNotes)
                            ? (_openBlock(), _createBlock(DataCard, {
                                key: 0,
                                "sub-title": "Release Notes",
                                icon: _unref(logoFigma),
                                value: _unref(currentUser)?.fgReleaseNotes,
                                "additional-info": "Images created this year by you"
                              }, null, 8, ["icon", "value"]))
                            : _createCommentVNode("", true),
                          (_unref(currentUser)?.fgWebsite)
                            ? (_openBlock(), _createBlock(DataCard, {
                                key: 1,
                                "sub-title": "Website",
                                icon: _unref(checkmarkDoneOutline),
                                value: _unref(currentUser)?.fgWebsite,
                                "additional-info": "Images created this year by you"
                              }, null, 8, ["icon", "value"]))
                            : _createCommentVNode("", true),
                          (_unref(currentUser)?.fgDocumentation)
                            ? (_openBlock(), _createBlock(DataCard, {
                                key: 2,
                                "sub-title": "Documentation",
                                icon: _unref(checkmarkDoneOutline),
                                value: _unref(currentUser)?.fgDocumentation,
                                "additional-info": "Images created this year by you"
                              }, null, 8, ["icon", "value"]))
                            : _createCommentVNode("", true),
                          (_unref(currentUser)?.fgEvent)
                            ? (_openBlock(), _createBlock(DataCard, {
                                key: 3,
                                "sub-title": "Event",
                                icon: _unref(checkmarkDoneOutline),
                                value: _unref(currentUser)?.fgEvent,
                                "additional-info": "Images created this year by you"
                              }, null, 8, ["icon", "value"]))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("aside", _hoisted_22, [
                      _cache[21] || (_cache[21] = _createElementVNode("h2", null, "Thats a wrap for 2024!", -1)),
                      _createVNode(_unref(IonLabel), null, {
                        default: _withCtx(() => [
                          _createTextVNode(" Thank you for an incredible year " + _toDisplayString(_unref(currentUser)?.firstName) + " " + _toDisplayString(_unref(currentUser)?.middleName) + " " + _toDisplayString(_unref(currentUser)?.lastName) + ". ", 1),
                          _cache[18] || (_cache[18] = _createElementVNode("br", null, null, -1)),
                          _cache[19] || (_cache[19] = _createElementVNode("br", null, null, -1)),
                          _cache[20] || (_cache[20] = _createElementVNode("p", null, " Every effort, every idea, every contribution you made this year is part of something greater. Together, we built solutions, solved challenges, and supported each other as a team. Thank you for being part of the HotWax family. ", -1))
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_23, [
                      _cache[25] || (_cache[25] = _createElementVNode("hr", null, null, -1)),
                      _createVNode(_unref(IonLabel), null, {
                        default: _withCtx(() => _cache[22] || (_cache[22] = [
                          _createTextVNode(" A special shoutout to the people who brought this to life. "),
                          _createElementVNode("br", null, null, -1),
                          _createElementVNode("br", null, null, -1),
                          _createTextVNode(" Built with ♥️ by Ajinkya, Harshita, Param, Parnika, Priyanshee, Shriya & Vidhan ")
                        ])),
                        _: 1
                      }),
                      _createElementVNode("div", _hoisted_24, [
                        _createVNode(_unref(IonButton), {
                          class: "ion-margin-top",
                          fill: "clear",
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (redirect()))
                        }, {
                          default: _withCtx(() => _cache[23] || (_cache[23] = [
                            _createTextVNode("Give feedback!")
                          ])),
                          _: 1
                        }),
                        _createVNode(_unref(IonButton), {
                          class: "ion-margin-top",
                          fill: "clear",
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (replay()))
                        }, {
                          default: _withCtx(() => _cache[24] || (_cache[24] = [
                            _createTextVNode("Replay!")
                          ])),
                          _: 1
                        })
                      ])
                    ])
                  ]))
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})